import { useAuthStore } from 'stores/auth-store'

export default async ({ to, from, next }) => {
  const authStore = useAuthStore()

  // Если маршрут требует аутентификации и пользователь не авторизован
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    // Сохраняем URL для перенаправления после входа
    authStore.returnUrl = to.fullPath
    return next('/login')
  }

  // Если пользователь авторизован и пытается войти на страницу входа
  if (to.path === '/login' && authStore.isAuthenticated) {
    return next(from ? from.path : '/')
  }

  // Для маршрутов, требующих аутентификации, проверяем токен
  if (to.meta.requiresAuth) {
    const isAuthenticated = await authStore.checkAuth()
    if (!isAuthenticated) {
      authStore.returnUrl = to.fullPath
      return next('/login')
    }
  }

  next()
}
